module.exports = __webpack_public_path__ + "static/media/stage6.a62d380e.svg";